import React, { useState, useCallback } from "react";

import Button from "cms/components/Button";
import { ButtonVariant } from "cms/components/Button/Button.styles";
import RichText from "cms/components/RichText";

import { Question, Answer, Arrow, Link } from "./FaqItem.styles";

export interface FaqItemProps {
  question: string | undefined | null;
  answer: Queries.Maybe<Record<string, unknown>> | undefined | string;
  button?: Queries.Maybe<Queries.SanityButton> | undefined;
}

const FaqItem: React.FC<FaqItemProps> = ({ question, answer, button }) => {
  const [isOpen, setOpen] = useState(false);
  const onClick = useCallback(() => {
    if (isOpen) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isOpen]);

  return (
    <React.Fragment>
      <Question onClick={onClick}>
        {question}

        <Arrow>
          {isOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="18 15 12 9 6 15" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          )}
        </Arrow>
      </Question>

      {isOpen && answer && (
        <Answer>
          {typeof answer === "string" ? (
            <p>{answer}</p>
          ) : (
            <RichText text={answer} />
          )}
        </Answer>
      )}

      {isOpen && button?.url && button?.label && (
        <Link href={button.url}>
          <Button
            label={button.label}
            variant={button.variant as ButtonVariant}
          />
        </Link>
      )}
    </React.Fragment>
  );
};

export default FaqItem;
